import { showConfirmationPrompt } from '@bpinternal/ui-kit-next'
import { useBlocker } from '@tanstack/react-router'

type PromptOptions = {
  title: string
  message: string
  confirmLabel: string
  cancelLabel: string
  confirmCallback?: () => Promise<boolean>
  cancelCallback?: () => Promise<boolean>
}

export const navigationBlockerOptions: PromptOptions = {
  title: 'Unpublished Changes',
  message: 'Do you want to publish your changes before continuing?',
  confirmLabel: 'Publish',
  cancelLabel: 'Leave',
  confirmCallback: async () => false,
  cancelCallback: async () => false,
}

export const defaultBlockerOptions: PromptOptions = {
  title: 'Are you sure you want to leave?',
  message: 'You have unsaved changes, all changes will be lost',
  confirmLabel: 'Leave',
  cancelLabel: 'Stay',
  confirmCallback: async () => false,
  cancelCallback: async () => true,
}

export default function useNavigationBlocker(
  hasPendingChanges: boolean,
  promptOptions: PromptOptions = defaultBlockerOptions
) {
  useBlocker({
    disabled: !hasPendingChanges,
    shouldBlockFn: async () => {
      if (hasPendingChanges) {
        try {
          await showConfirmationPrompt(promptOptions.message, {
            title: promptOptions.title,
            cancelLabel: promptOptions.cancelLabel,
            confirmLabel: promptOptions.confirmLabel,
          })

          await promptOptions.confirmCallback?.()
          return true
        } catch {
          await promptOptions.cancelCallback?.()
          return false
        }
      }
      return false
    },
  })
}
